import React from 'react'

class SelectBox extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isActive: false
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.onOutsideClick)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onOutsideClick)
  }

  onOutsideClick = (evt) => this.setState({ isActive: this.selectbox.contains(evt.target)})

  renderInput = () => {
    const { data, value, children, defaultName } = this.props
    return children || (
      <span className={this.props.spanClassName}>
        {data && value && data.filter(it => it.value === value)[0].name || defaultName}
        <i className="fa fa-caret-down ml-2" />
      </span>
    )
  }

  onSelect = value => () => {
    this.props.onSelect(value)
    this.setState({ isActive: false })
  }

  renderItem = (value, name) =>
    (
      <li
        onClick={this.onSelect(value)}
        key={value}
        style={{ cursor: 'pointer' }}
        className="list-unstyled"
      >{name}</li>
    )

  renderList = () =>
    (
        <ul className={this.props.ulClassName}>
          {this.props.header && <li className="title list-unstyled">
            {this.props.header}
            <hr />
          </li>}
          {this.props.data && this.props.data.map(it => this.renderItem(it.value, it.name))}
        </ul>
    )

  bindRef = selectbox => this.selectbox = selectbox

  render() {
    return (
      <section
        className={this.props.sectionClassName || ''}
        ref={this.bindRef}
      >
        {this.renderInput()}
        {this.state.isActive && this.renderList()}
      </section>
    )
  }

}

export default SelectBox